import type { ComponentInstance } from '../component.js';
import { safeLink, setHtmlIcon, setText } from '../dom-helpers.js';
import { ICON_ERROR } from '../icons.js';

export interface ErrorNotFoundProps {
  embed: boolean;
}

export function mountErrorNotFound(
  root: HTMLElement,
  initial: ErrorNotFoundProps,
): ComponentInstance<ErrorNotFoundProps> {
  root.innerHTML = '';

  const panel = document.createElement('div');
  panel.classList.add('viewer-ui-interactive');
  panel.setAttribute('role', 'alert');
  panel.style.cssText = initial.embed
    ? 'position:fixed;bottom:1rem;left:50%;transform:translateX(-50%);background:rgba(15,15,17,0.92);backdrop-filter:blur(8px);color:#f4f4f5;padding:0.875rem 1.125rem;border-radius:0.5rem;max-width:24rem;font-family:system-ui,sans-serif;font-size:0.875rem;display:flex;align-items:flex-start;gap:0.75rem;pointer-events:auto'
    : 'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(9,9,11,0.92);color:#f4f4f5;font-family:system-ui,sans-serif;pointer-events:auto';

  const inner = document.createElement('div');
  inner.style.cssText = initial.embed
    ? 'display:flex;align-items:flex-start;gap:0.75rem'
    : 'max-width:32rem;text-align:center;padding:2rem;display:flex;flex-direction:column;align-items:center;gap:1rem';

  const iconEl = document.createElement('div');
  iconEl.setAttribute('aria-hidden', 'true');
  setHtmlIcon(iconEl, ICON_ERROR);
  inner.appendChild(iconEl);

  const textWrap = document.createElement('div');
  textWrap.style.cssText = 'display:flex;flex-direction:column;gap:0.5rem;max-width:24rem';
  inner.appendChild(textWrap);

  const heading = document.createElement('p');
  heading.style.cssText = initial.embed ? 'font-weight:500' : 'font-size:1.25rem;font-weight:600';
  setText(heading, 'Link non valido');
  textWrap.appendChild(heading);

  const body = document.createElement('p');
  body.style.cssText = 'color:#a1a1aa;line-height:1.5';
  setText(
    body,
    'Il link che hai aperto non corrisponde a un modello esistente. Controlla che sia stato copiato per intero.',
  );
  textWrap.appendChild(body);

  const home = safeLink('https://oniri.space', 'Vai al sito');
  home.style.cssText =
    'margin-top:0.5rem;display:inline-block;color:#f4f4f5;border:1px solid rgba(255,255,255,0.2);border-radius:0.375rem;padding:0.375rem 0.75rem;text-decoration:none;font-size:0.875rem';
  textWrap.appendChild(home);

  panel.appendChild(inner);
  root.appendChild(panel);

  return {
    update() {
      // No props change for terminal not-found.
    },
    cleanup() {
      panel.remove();
    },
  };
}
